import {Component} from '@angular/core';

@Component({
  selector: 'app-expression-functions',
  templateUrl: './expression-functions.component.html',
  styleUrls: ['./expression-functions.component.css']
})
export class ExpressionFunctionsComponent {

}
